export const transUk = {
    myLocal: {
        columns: 'Columns',
        hide_filter: 'Pre-Filters', //'Hide Filter',
        show_filter: 'Pre-Filters', //'Show Filter',
    },
    dbFields: {},

   "To download the order file, you must first stop the order unloading to the accounting system.": "Щоб скачати файл із замовленням, спочатку потрібно зупинити вигрузку замовлення в облікову систему.",
   "Enter the text that will appear when hovering over the INFO icon on the pool card in the filter interface.": 'Вкажіть текст, який відображатиметься при наведенні на іконку ІНФО на картці басейну в інтерфейсі фільтра.',
   'Filter (pool)': 'Фільтр (басейн)',

    "Cancel": "Скасувати",
    "Confirmed": "Підтвердити",
    "Are you sure you want to stop unloading to the accounting system?": " Ви впевнені, що хочете зупинити вигрузку замовлення в облікову систему?",
    "Are you sure you want to resume unloadingto the accounting system?": "Ви впевнені, що хочете відновити вигрузку в облікову систему?",
    "Stop unloading": "Зупинити вигрузку",
    "Resume unloading": "Відновити вигрузку",

    "Create address": "Створення адреси",
    "Creating a delivery address for partner": "Створення адреси доставки для партнера",
    "Request No": "Заявка №",

    "Filled": "Заповнено",
    "Not filled": "Не заповнено",
    "Update counterparty properties": "Оновити властивості контрагентів",
    "Update Main Warehouse": "Оновити Основний склад",
    "Update Pickup Warehouses": "Оновити Склади самовивозу",
    "Update Exception Warehouses": "Оновити Склади-винятки",
    "Update TP Info and Managers": "Оновити інфо ТП і Менеджери",

    "Source": "Джерело ",
    "Warehouse": "Склад",
    "Invoice": "Накладна",
    "Article": "Артикул",
    "Orders": "Замовлення",
    "Amount": "Сума",
    "Initial amount": "Сумма початкова",
    "Current amount": "Сумма поточна",
    "Quantity: current (initial)": "Кількість: поточна (початкова)",

    '---None---': '--- Не заповнено ---',
    'Add / Delete Categories': 'Додати / Видалити Категорії',
    'Add Categories': 'Додати категорії',
    'Delete Categories': 'Видалити категорії',
    'File selected': 'Вибрано файл',
    'Export to Excell': 'Вивантажити в Excell',
    'Import from Excell': 'Завантажити з Excell',
    'Uploading file': 'Завантаження файлу',
    'Field of activity': 'Напрямок діяльності',
    'Property of belonging to a region': 'Властивість приналежності до регіону',
    'Select filters (optional)': 'Виберіть фільтри (опціонально)',
    'Unloading counterparties': 'Вивантаження контрагентів',
    'Loading counterparties': 'Завантаження контрагентів',
    'Unloading selected counterparties': 'Вивантаження вибраних контрагентів',

    'Available warehouses for pickup': 'Доступні склади для самовивозу',
    'Available warehouses for pickup (comment)': 'Склади, перелічені в цьому полі, будуть доступні при виборі типу доставки «Самовивіз». Основний склад контрагента за замовчуванням доступний для самовивозу, тому його не обов’язково вказувати в цьому полі.',
    'Excluded warehouses': 'Склади-виключення',
    'Excluded warehouses (comment)': 'Якщо для контрагента потрібно приховати (виключити) деякі склади, необхідно вказати їх у цьому полі. Ці склади не відображатимуться в результатах пошуку та в кошику. Інші склади будуть доступні.',

    'error type delivery': 'Для однієї адреси партнера можна додати лише маршрути доставки з однаковим типом доставки. Будь ласка, переконайтеся, що всі обрані маршрути мають один тип доставки.',

    'Loading goods': 'Завантаження товару',
    'Quantity in file': 'Кількість у файлі',
    'Not found': 'Не знайдено',
    'Validation errors': 'Помилки перевірки',

    'Trade Marks': 'Торгова марка',
    'Page Title': 'Заголовок сторінки',
    'Archive': 'Архів',
    'Priority': 'Пріоритет',
    'Link to page': 'Посилання на сторінку',
    'Link to catalog in search': 'Посилання на каталог у пошуку',
    "Link to manufacturer's catalog": 'Посилання на каталог виробника',
    "Manufacturer's website": 'Сайт виробника',
    'Country': 'Країна',
    'Cross code file(csv or xls)': 'Файл крос-кодів(csv або xls)',

    'Status': 'Статус',
    'Required field': "Обов'язково для заповнення",

    'Badge': 'Бейдж',
    'Promotion Type': 'Тип акції',
    'Promotion type': 'Тип акції',
    'Product Gift': 'Подарунковий товар',
    'Fix price currency': 'Валюта фіксованої ціни',
    'Sort': 'Сортувати',
    'RGB code': 'RGB код',
    'RGB badge name code': 'RGB код назви бейджа',
    'Promotion Badge': 'Бейдж акції',
    'Promotion': 'Акції',
    'Discount Rule': 'Правило знижки',

   "Code": "Код",

    "Show on creation customer process": "Відображати на формі створення клієнта",
    "Partners delivery address": "Адреса доставки партнера",
    "Partners delivery addresses": "Адреси доставки партнера",
    "Select a user from the list": "Вибрати користувача зі списку",
    "Enter new user": "Ввести нового користувача",
    "Go to client": "Перейти до клієнта",
    "This field already exists": "Таке поле вже існує",
    "Client saved": "Клієнт успішно збережений",
    "Create new client": "Створити нового клієнта",
    "Delivery Routes": "Маршрути доставки",
    "Need to specify an address for the counterparty": "Потрібно вказати адресу для контрагента",
    "Delete": "Видалити",
    "Route": "Маршрут",
    "Routes": "Маршрути",
    "Auto": "Авто.",
    "Create client": "Створення клієнта",
    "Partner from list": "Вибрати партнера зі списку",
    "New customer": "Новий контрагент",
    "New customers": "Нові контрагенти",
    "New partner": "Створити нового партнера",
    "Create Partner": "Створити партнера",
    "Save": "Зберегти",
    "Accounting phone": "Телефон бухгалтерії",
    "Warehouse phone": "Телефон складу",
    "Accounting email": "Електронна пошта бухгалтерії",
    "Partner information": "Інформація про партнера",
    "Partner customers": "Контрагенти партнера",
    "Partner address": "Адреси партнера",
    "Delivery": "Доставка",
    "Create partner": "Створити партнера",
    "Create customers": "Створити контрагентів",
    "Customers for partner": "Створення контрагентів для партнера",
    "Add customer": "Додати ще одного контрагента",
    "Add address": "Додати ще одну адресу",
    "Settings for pricing": "Налаштування ціноутворення",
    "Common data": "Загальні дані",
    "Customer users": "Користувачі контрагента",
    "Back": "Назад",
    "Next": "Далі",
    "Old address": "Раніше додані адреси",
    "Address for partner": "Адреси для партнера",
    "Save partners data": "Зберегти дані партнера",
    "Save clients data": "Зберегти дані клієнта",
    "New address": "Нова адреса",
    "Select from list": "Обрати зі списку",
    "this value already exists": "таке значення вже існує",

    "Customer property": "Свойства контрагента",

    "Is Active": "Активний",
    "Is Superuser": "Суперкористувач",
    "Is Staff": "Персонал",
    "First Name": "Им'я",
    "Middle name": "По батькові",
    "Last Name": "Прізвище",
    "Partner": "Партнер",
    "Partners": "Партнери",
    "User": "Користувач",
    "Users": "Користувачі",
    "Create user": "Створити користувача",
    "Categories": "Категорії",
    "Password": "Пароль",
    "Change password": "Змінити пароль",
    "Confirm password": "Підтвердити пароль",
    "The password is required (length > 5)": "Потрібно ввести пароль (довжина > 5)",
    "Password confirmation error": "Помилка підтвердження пароля",
    //-----------------------
    "Phone": "Телефон",
    "Phones": "Телефони",
    "Official name": "Офіційне найменування",
    "Customer name": "Найменування контрагента",
    "Code from the accounting system": "Код з облікової системи",
    "Client code": "Код клієнта",
    "Main warehouse": "Основний склад",
    "Legal address": "Юридична адреса",
    "Physical address": "Фізична адреса",
    "Credit limit currency": "Валюта кред. ліміту",
    "Credit limit term (days)": "Термін кред. ліміту (днів)",
    "Credit limit amount": "Сума кред. ліміту",
    "Contractor type": "Тип контрагенту",

    "Processed": "Оброблено",
    "Client wish": "Побажання клієнта",
    "Business type": "Вид діяльності",
    "Customer requests": "Заявки клієнтів",
    "Request type": "Тип заявки",
    "Application closed": "Заявку закрито",
    "Partner name": "Найменування партнера",
    "Partner phone": "Телефон партнера",
    "Partner email": "Пошта партнера",

    "VAT payer": "Платник ПДВ",
    "EDRPOU": "ЄДРПОУ",
    "Tax number": "ІПН",
    "VAT identification number": "Ід. номер ПДВ",
    "How to show quantity": "Як показувати наявність",
    "Retail margin": "Роздрібна націнка",
    //-----------------------
    "Manager": "Менеджер",
    "Sales representative SNG": "ТП СНГ",
    "Sales representative Ino": "ТП іномарки",

    "Confirm": "Підтверждено",
    "Disable": "Відключено",
    "Address": "Адреса",
    "Saved Address": "Сохраненный адрес",
    "Address lat / lon": "Адрес lat / lon",
    "Area": "Область",
    "Region": "Район",
    "Point": "Населений пункт",
    "Street": "Вулиця",
    "House": "Будинок",
    "Flat": "Квартира",
    "Deliveries": "Доставки",
    "Comment": "Коментар",
    "Placement": "Розташування",
    "Partner Address": "Адрес партнера",

    "Check coordinates on the map": "Проверить координаты на карте",
    "Fill in coordinates manually": "Заполнить координаты вручную ",
    "Functionality under development": "Функционал в разработке",
    "Automatic address filling": "Автоматическое заполнение адреса",//"Автоматичне заповнення адреси",
    //-----------------------

    ignore: 'игнорировать',

    "Select file": "Обрати файл",
    "Download file": "Завантажити файл",
    "Clear": "Очистити",

    "Amount (base price)": "Сумма (базовая цена)",
    "Amount (regular price)": "Сумма (регулярная цена)",
    "Total order including discounts": "Итого заказ с учетом скидок",

    add: 'добавить',
    absorb: 'поглощать',
    absorbed_by: 'поглощен (кем/чем)',
    maximum: 'максимум',
    minimum: 'минимум',

    'Active': 'Активний',
    Additionally: 'Дополнительно',
    'Applied Rule': 'Применяемое правило',
    'Absorbed Rule': 'Заменяемое правило',

    'Base price': 'Базовая цена',
    BONUSES: 'БОНУСЫ',
    Bonuses: 'Бонусы',
    'Bonus': 'Бонус',
    'bonus': 'бонус',
    Brands: 'Бренды',
    Brand: 'Бренд',
    brand_ref: 'Бренд (справочник)',
    Brand_ref: 'Бренд (справочник)',
    BrandsSynonyms: 'Синонимы бренда',
    Brandssynonyms: 'Синонимы бренда',
    BrandsReplacement: 'Замены брендов в прайсах поставщиков',
    Brandsreplacement: 'Замены брендов в прайсах поставщиков',
    BrandImage: 'Изображение бренда',
    Brandimage: 'Изображение бренда',
    brands_country: 'Страна бренда',
    'Brands By Rule': 'Бренды по правилам',

    'complicated_rule': 'сложное правило',
    'customer': 'контрагент',
    'Clear Result': 'Очистить результат',
    COMMON: 'ОБЩИЕ',
    Common: 'Общие',
    Characteristics: 'Характеристики',
    Customers: 'Контрагенти',
    Customer: 'Контрагент',
    CREATED: 'СОЗДАНО',
    Created: 'Создано',
    created: 'создано',
    CREATE: 'СОЗДАНО',
    Create: 'Создано',
    create: 'создано',
    Currencies: 'Валюта',
    Currency: 'Валюта',
    'Customer Property Value': 'Значение Свойств Контрагента',
    'Current Discount Rule': 'Текущее Правило Скидки',
    'Customer Discount By Rule': 'Скидка клиента по правилу',
    'Complicated Discount By Rule': 'Сложная скидка по правилу',

    DESCRIPTION: 'ОПИС',
    description: 'опис',
    Description: 'Опис',
    DiscountCustomerBrand: 'Значение дисконта',
    DiscountcustomerBrand: 'Значение дисконта',
    Discount: 'Знижка',
    "Discount Property": 'Свойства Скидок',
    "Discount property": 'Свойства скидок',
    'Discount Rules': 'Правила Скидок',
    'Discount By Rule': 'Скидка по правилу',
    'Discount Property Value': 'Значение Свойств Скидок',
    'Discount property value': 'Значение свойств скидок',
    'Discount Relationship': 'Отношения Скидок',
    'Discount relationship': 'Отношения скидок',
    'Discount Relation Ship': 'Отношения скидок',
    'Default Discount': 'Скидки по умолчанию',
    'Default Relation': 'Отношение по умолчанию',
    'Date From': 'Дата з',
    'Date To': 'Дата по',

    'Earlier': 'Ранее',
    'Export Customer Properties': 'Экспорт свойств контрагента',

    'For All Products': 'Для Всех Товаров',
    'Fix price': 'Фикс. цена',

    'Go Back': 'Вернуться',

    hidden_for_user: 'скрывать для пользователя',
    'History': 'История',

    massive: 'габаритный',

    'Last Rule': 'Последнее правило',

    // NO: 'НЕТ',
    // YES: 'ДА',
    // No: 'Нет',
    // Yes: 'Да',

    name: 'найменування ',
    Name: 'Найменування ',

    'Order discounts': 'Скидка на заказ',
    original_brand: 'оригинальный бренд',
    Other: 'Другие',
    'Min.amount of non-prom. item': 'Мин.сумма неакц-го товара',
    'Min.order amount': 'Мин.сумма заказа',
    'Min. amount': 'Мин. сумма',

    'Order Quantity': 'Кількість (заказ)',
    'order': 'заказ',
    'Order': 'Заказ',

    'Quantity': 'Кількість',
    'quantity': 'Кількість',

    Prefixes: 'Префикс',
    'Price with order discounts': 'Цена со скидкой при заказе',
    'PRODUCTS': 'ПРОДУКТЫ',
    Protected: 'Защищено',
    protected: 'защищено',
    Products: 'Товары',
    Product: 'Товар',
    'Products By Rule': 'Товары по правилам',
    'Product Property': 'Свойства Товара',
    'Product Property Value': 'Значения Свойств Товара',
    'Price Currency': 'Валюта Цены',
    'Price': 'Ціна',
    'product': 'товар',

    'Price Of Week': 'Цена недели',
    'Price of week': 'Цена недели',

    'Regular discounts': 'Регулярные скидки',
    'Regular price': 'Регулярная цена',
    'Related Table': "Доп. Таблиці",
    "Related table": 'Доп. таблиці',
    'Rule type': 'Тип правила',
    'Rule Type': 'Тип Правила',
    'Rate': 'курс',
    'Relaited Discount Rule': 'Правило Связанных Скидок',
    'Relation': 'Отношение',

    // "Brand_ref": 'Бренд (справочник)',
    Index: "Индекс",
    index: "индекс",
    is_new: 'Новый',
    is_offer: 'Акция',
    is_populate: 'Популярный',
    is_sale: 'Распродажа',

    Specification: 'Спецификация',
    sku: 'ску',
    source: 'источник',
    Suffixes: 'Суфикс',
    'Save & Close': 'Сохранить и выйти',
    'Search': 'Пошук',

    'Test': "Проверка",
    'Test Price': 'Проверка цены',
    'Test Order': 'Проверка заказа',
    Today: 'Сегодня',
    'This week': 'Эта неделя',
    'This month': 'Этот месяц',

    Updated: 'Змінено',
    updated: 'змінено',
    Update: 'Змінено',
    update: 'змінено',
    "Units of Measure": 'Еденицы измерения',
    uuid: 'uuid',

    'PROTECTED RECORDS. Creation of related tables prohibited': 'ЗАЩИЩЕННЫЕ ЗАПИСИ. Создание сопутствующих таблиц запрещено',
    'Editing of related tables will be available after record creation': "Редактирование сопутствующих таблиц буде доступно после создания записи",
    remove_alternate_parent: "Видалити альтернативний зв'язок з %{parent_name}",
    replace_alternate_to_parent: "Зробити %{parent_name} прямим батьком і зробити зв'язок з %{alternate_parent_name} альтернативним",
    replace_parent: "Зробити %{parent_name} прямим батьком та видалити зв'язок із %{alternate_parent_name}",
    remove_parent: "Видалити прямий зв'язок із %{parent_name}",
    make_alternative: "Зробити %{parent_name} альтернативним батьком",
    make_direct: "Зробити %{parent_name} прямим батьком",
    undo_action: 'Скасувати дію',
    categories_tree: 'Дерево Категорій',
    edit_category: 'Редагувати категорію',
    show_hidden_categories: 'Показати приховані для користувача категорії',
    hidden_for_user_category: 'Приховано',
    show_category_for_user: 'Відобразити категорію для користувача',
    hide_category_for_user: 'Приховати категорію для користувача',
    mixed: 'Змішана',
    group_only: 'Тільки категорії',
    item_only: 'Тільки товари',
    'Hierarchy type': 'Тип ієрархії',
    'Hide category and its products': 'Приховати категорію та її продукти',
    'Display On Main Page': 'Показати на головній сторінці',
    'Display in Header and/or Catalogue tree': 'Відображення в Header та/або каталогу',
    'Use as Filter in listing': 'Використовувати як фільтр у списку',
    hidden_for_user_description: 'Якщо встановлена ​​ознака, категорія та її підкатегорії повністю ховаються на сайті. Також будуть приховані всі товари, для яких цю категорію чи будь-яку з її підкатегорій встановлено як батьківську. Товари не відображатимуться, включаючи результати пошуку.',
    show_on_main_description: 'Вкажіть, чи категорія повинна відображатися в блоці на головній сторінці сайту. Зазвичай це категорії, що просуваються компанією.',
    show_on_menu_description: 'Вкажіть, чи категорія повинна відображатися в меню сайту, включаючи хедер або дерево категорій, якщо це передбачено дизайном.',
    show_on_filter_description: 'Вкажіть, чи категорія повинна відображатися у фільтрах на сторінці лістингу. Наприклад, при пошуку "Фільтри" у фільтрах лістингу можуть з\'являтися такі категорії, як "Повітряні", "Олійні", "Кондиціонера".',
    'Display type': 'Тип відображення',
    show_category: 'Відображати категорію',
    hide_category_show_children: 'Не відображати категорію, АЛЕ відображати вкладені',
    hide_category_and_children: 'Не відображати категорію та приховати всі вкладені',
    pool_description: 'Опис басейну'
}
